<div class="panel_wrapper">
  <div class="d-flex flex-row mb-2">
    <div class="capacity_type_div" (click)="chooseType(capacityTypeEnum.DEFAULT)">
      <div *ngIf="isTypeSelected(capacityTypeEnum.DEFAULT)" class="capacity_type_selection_selected"></div>
    </div>
    <span class="lbl_resy_field w-50 cursor-pointer">{{'VENUE.DEFAULT' | translate}}</span>
  </div>
  <div class="d-flex flex-row mb-2">
    <div class="capacity_type_div" (click)="chooseType(capacityTypeEnum.SEASONAL)">
      <div *ngIf="isTypeSelected(capacityTypeEnum.SEASONAL)" class="capacity_type_selection_selected"></div>
    </div>
    <span class="lbl_resy_field w-50 cursor-pointer">{{'VENUE.SEASONAL' | translate}}</span>
  </div>
  <div class="d-flex flex-row justify-content-between pt-3">
    <button class="btn_without_color w-50 m-0" (click)="cancel()">{{'CLOSE' | translate}}</button>
    <button class="create_btn w-50" (click)="openDialog()">{{'CREATE' | translate}}</button>
  </div>
</div>
